// components/Tables/HistoryTable.js
import React from 'react';

const HistoryTable = ({ data = [], onDownload }) => {
  const { state_child, statuses_types } = require('../../../../../../cabinet/components/CabinetChildrenCard/data/statuses');

    const getPlaceTypeName = (placeType) => {
        const typeMap = {
            'standart': 'Повного дня',
            'without-bed': 'Короткотривале',
            'inclusive': 'Інклюзивне',
            'inclusive-short': 'Інклюзивне короткотривале'
        };
        return typeMap[placeType] || placeType;
    };

  return (
    <div className="table-responsive">
      <table className="table table-history mb-0">
        <thead>
          <tr>
            <th>№</th>
    <th>Дата</th>
            <th>Подія</th>
            <th>Сад</th>
            <th>Група</th>
            <th>Тип</th>
            <th>Район</th>
          </tr>
        </thead>
        <tbody>
          {data.map((status, index) => {
            const st_translate = status.action ? 
              (statuses_types.find(st => st.action === status.action)?.translate || status.action)
              :
              (state_child[status.state]) || status.state;
            
            const who_info = status.initiator ?
              'Перевів: ' + [status.initiator.firstName, status.initiator.middleName, status.initiator.lastName].join(" ")
              :
              '';

            const info_about_dissmiss = status.removalOrder && status.removalOrder.number && 
              `Наказ №${status.removalOrder.number} ${new Date(status.removalOrder.date).toLocaleDateString('uk-UA')}` || ''
            

            const link_doc = status.removalOrder && status.removalOrder.orderDoc || null;

            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{new Date(status.statusInsertDate).toLocaleDateString('uk-UA')} {new Date(status.statusInsertDate).toLocaleTimeString('uk-UA')}</td>
                <td className={status.state === 'expelled' ? 'reject' : ''}>
                  <div>{st_translate}</div>
                  <div className="commentinfo">{who_info}</div>
                  <div title="Завантажити" className="commentinfo link" onClick={()=>onDownload(link_doc)}>{info_about_dissmiss}</div>
                </td>
                <td>{status.kindergartenNumber}</td>
                <td>{status.groupNumber}</td>
                <td>{getPlaceTypeName(status.placeType)}</td>
                <td>{status.kindergartenDistrict}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default HistoryTable;